import React from 'react';
import { useRef } from 'react';
import useProfileStore from '../store/profileStore';
import useDragLineStore from '../store/dragLineStore';

function Background() {

  const planeRef = useRef();
  const size = 500;
  const addSelectedPts = useProfileStore(state => state.addSelectedPts)
  const addCurrentPt = useDragLineStore(state => state.addCurrentPt)
  const dragMode = useDragLineStore(state => state.dragMode)

  var addPt = (e) => {
    if (dragMode) {
    addSelectedPts([e.point.x,e.point.y,0]);}
    console.log(e.point.x, e.point.y)

  }

  var setCurrentPt = (e) => {
    if(dragMode){
      e.stopPropagation()
      addCurrentPt([e.point.x,e.point.y,0])

    }
  }


  return (
    <>
      <group ref={planeRef}>
        <mesh position={[0,0,-0.001]}  onClick={addPt} onPointerMove={setCurrentPt}  >
          <planeBufferGeometry args={[size,size]}/>
          <meshBasicMaterial color='#FFFBE5'  toneMapped={false}/>
        </mesh>
      </group>
    
    </>
  )
}

export default Background
